import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import { datadogRum } from '@datadog/browser-rum';
import { angularPlugin } from '@datadog/browser-rum-angular';

if (!environment.local) {
    datadogRum.init({
        applicationId: environment.DD_APP_ID,
        clientToken: environment.DD_CLIENT_TOKEN,
        site: 'us5.datadoghq.com', // or datadoghq.eu
        service: 'rms-angular',        // name your app
        env: 'staging',                  // prod/dev/staging
        version: '1.0.0',

        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,

        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        allowedTracingUrls: [environment.WS_URL, environment.RMS_URL], // add your API endpoints here
        plugins: [angularPlugin()] // ✅ THIS is the Angular integration
    });
    console.log(environment);

    // optional
    datadogRum.startSessionReplayRecording();
}


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
